import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  footerWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    alignItems: 'center',
    marginRight: theme.spacing(5),
  },
  clearFormButton: {
    marginRight: theme.spacing(3),
  },
  footerCustomClass: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
}))
